<script setup>
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
</script>

<script>
import {mapState} from 'pinia';
import {useAuthStore} from "@dutypay/store-modules";
import findIndex from "lodash/findIndex";

export default {
  name: 'AdminSettings',
  computed: {
    ...mapState(useAuthStore, ['user']),
    renderAdminSettings() {
      return (findIndex(this.user.roles, (item) => {return item === 'global:admin'}) !== -1);
    }
  }
}
</script>

<template>
  <div>
    <h1>{{ t('adminSettings.title') }}</h1>
    <router-view v-if="renderAdminSettings"></router-view>
    <p v-else>{{ t('noPermission.label') }}</p>
  </div>
</template>

<i18n>
{
  "ar-AE": {
    "adminSettings": {
      "title": "إعدادات المسؤول"
    }
  },
  "ar-EG": {
    "adminSettings": {
      "title": "إعدادات المسؤول"
    }
  },
  "ar-SA": {
    "adminSettings": {
      "title": "إعدادات المسؤول"
    }
  },
  "de-DE": {
    "adminSettings": {
      "title": "Administratoreinstellungen"
    }
  },
  "de-AT": {
    "adminSettings": {
      "title": "Administratoreinstellungen"
    }
  },
  "de-CH": {
    "adminSettings": {
      "title": "Administratoreinstellungen"
    }
  },
  "en-US": {
    "adminSettings": {
      "title": "Administrator Settings"
    }
  },
  "en-GB": {
    "adminSettings": {
      "title": "Administrator Settings"
    }
  },
  "it-IT": {
    "adminSettings": {
      "title": "Impostazioni amministratore"
    }
  },
  "fr-FR": {
    "adminSettings": {
      "title": "Paramètres administrateur"
    }
  },
  "es-ES": {
    "adminSettings": {
      "title": "Configuraciones de administrador"
    }
  },
  "pl-PL": {
    "adminSettings": {
      "title": "Ustawienia administratora"
    }
  },
  "nl-NL": {
    "adminSettings": {
      "title": "Beheerdersinstellingen"
    }
  },
  "bg-BG": {
    "adminSettings": {
      "title": "Настройки на администратора"
    }
  },
  "bs-BA": {
    "adminSettings": {
      "title": "Postavke administratora"
    }
  },
  "da-DK": {
    "adminSettings": {
      "title": "Administratorindstillinger"
    }
  },
  "et-EE": {
    "adminSettings": {
      "title": "Administraatori seaded"
    }
  },
  "fi-FI": {
    "adminSettings": {
      "title": "Järjestelmänvalvojan asetukset"
    }
  },
  "el-GR": {
    "adminSettings": {
      "title": "Ρυθμίσεις διαχειριστή"
    }
  },
  "he-IL": {
    "adminSettings": {
      "title": "הגדרות מנהל"
    }
  },
  "ga-IE": {
    "adminSettings": {
      "title": "Socruithe riarthóra"
    }
  },
  "ja-JP": {
    "adminSettings": {
      "title": "管理者設定"
    }
  },
  "hr-HR": {
    "adminSettings": {
      "title": "Postavke administratora"
    }
  },
  "lv-LV": {
    "adminSettings": {
      "title": "Administratora iestatījumi"
    }
  },
  "lt-LT": {
    "adminSettings": {
      "title": "Administratoriaus nustatymai"
    }
  },
  "pt-PT": {
    "adminSettings": {
      "title": "Configurações de administrador"
    }
  },
  "ro-RO": {
    "adminSettings": {
      "title": "Setări administrator"
    }
  },
  "ru-RU": {
    "adminSettings": {
      "title": "Настройки администратора"
    }
  },
  "sv-SE": {
    "adminSettings": {
      "title": "Administratörsinställningar"
    }
  },
  "sk-SK": {
    "adminSettings": {
      "title": "Nastavenia správcu"
    }
  },
  "cs-CZ": {
    "adminSettings": {
      "title": "Nastavení správce"
    }
  },
  "tr-TR": {
    "adminSettings": {
      "title": "Yönetici ayarları"
    }
  },
  "hu-HU": {
    "adminSettings": {
      "title": "Rendszergazda beállításai"
    }
  },
  "fr-BE": {
    "adminSettings": {
      "title": "Paramètres administrateur"
    }
  },
  "fr-LU": {
    "adminSettings": {
      "title": "Paramètres administrateur"
    }
  },
  "mt-MT": {
    "adminSettings": {
      "title": "Is-settings tal-amministratur"
    }
  },
  "sl-SI": {
    "adminSettings": {
      "title": "Nastavitve skrbnika"
    }
  },
  "el-CY": {
    "adminSettings": {
      "title": "Ρυθμίσεις διαχειριστή"
    }
  },
  "tr-CY": {
    "adminSettings": {
      "title": "Yönetici ayarları"
    }
  },
  "uk-UA": {
    "adminSettings": {
      "title": "Налаштування Адміністратора"
    }
  },
  "zh-CN": {
    "adminSettings": {
      "title": "管理员设置"
    }
  }
}
</i18n>
